import { $isTableCellNode, $isTableNode, $isTableRowNode } from "@lexical/table";
import { $isRootNode } from "lexical";
import { $isDataTableCellNode, $isDataTableNode } from "../nodes/data-table-node";

import type { LexicalNode } from "lexical";

export const $isInTableNode = (node: LexicalNode): boolean => {
  if ($isTableNode(node) || $isTableRowNode(node) || $isTableCellNode(node)) {
    return true;
  }

  const parent = node.getParent();
  if (!parent || $isRootNode(parent)) return false;

  return $isInTableNode(parent);
};

export const $isInDataTableNode = (node: LexicalNode): boolean => {
  if ($isDataTableNode(node) || $isDataTableCellNode(node)) {
    return true;
  }

  const parent = node.getParent();
  if (!parent || $isRootNode(parent)) return false;

  return $isInDataTableNode(parent);
};
